import React from 'react';

import ButtonPill from "@components/button-pill";

import './index.scss';

export type PillOption = {
  label: string;
  value: any;
}

type InputPillProps = {
  handleClick: (option: PillOption) => void;
  options: PillOption[]
};

const InputPill = ({ options, handleClick }: InputPillProps): JSX.Element => {
  return (
    <div className="input-pill-container">
      {options.map(opt => (
        <ButtonPill key={opt.value} className="input-pill-fade-in" onClick={() => handleClick(opt)}>{opt.label}</ButtonPill>
      ))}
    </div>
  );
};

export default InputPill;